exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-responsive[data-v-69dce2cf] {\n  position: relative;\n}\n.table-responsive.table-loading[data-v-69dce2cf] {\n  min-height: 200px;\n}\n.loading[data-v-69dce2cf] {\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.8);\n}\n.fade-enter-active[data-v-69dce2cf],\n.fade-leave-active[data-v-69dce2cf] {\n  transition: opacity 0.2s;\n}\n.fade-enter[data-v-69dce2cf], .fade-leave-to[data-v-69dce2cf] {\n  opacity: 0;\n}", ""]);

// exports
